var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66895 0.864L7.99995 0L6.33095 0.864L4.47295 1.146L3.63095 2.826L2.29395 4.146L2.59995 6L2.29395 7.854L3.63095 9.174L4.47295 10.854L6.33095 11.136L7.99995 12L9.66895 11.136L11.5269 10.854L12.3689 9.174L13.7059 7.854L13.3999 6L13.7059 4.146L12.3689 2.826L11.5269 1.146L9.66895 0.864ZM10.8649 2.057L11.5489 3.422L12.6349 4.494L12.3869 6L12.6349 7.506L11.5489 8.578L10.8649 9.943L9.35495 10.172L7.99995 10.874L6.64495 10.172L5.13495 9.943L4.45095 8.578L3.36495 7.506L3.61395 6L3.36395 4.494L4.45095 3.422L5.13495 2.057L6.64495 1.828L7.99995 1.126L9.35595 1.828L10.8649 2.057Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.7939V15.9999L8 14.9999L12 15.9999V11.7939L9.982 12.0999L8 13.1259L6.018 12.0999L4 11.7939Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.2adb2e95645c31f0a2c17b16b5bee204.svg";
export { ForwardRef as ReactComponent };